/**
 * MY (马来西亚) 常量覆写
 * 仅覆写与默认值不同的 key，命名规则同 diffconfig/config/constants.ts：Module-Page-Constant
 */
export default {
  'Common-Api-CountryCode': 'MY',
  'Common-Currency-Symbol': 'RM',
  'Store-PrintLabel-Size': '100x110',
    // ─── Address 地址模块 ──────────────────────────────────
  /** 地址选择器 label 文案 */
  'Address-Selector-Label': '邮编/县/市/省'
}
